import AuthMixin from '@/components/mixins/auth-mixin'

export default {
  name: 'generalTermsAndConditionsOfSale',
  components: {},
  props: {
    dataProp: {
      type: String,
      default () { return '' }
    }
  },
  watch: {},
  mixins: [AuthMixin],
  data () {
    return {}
  },
  methods: {},
  mounted () {
    this.isAuthenticated()
  }
}
